const React = require('react'),
    {PropTypes} = require('react');


const FlatSphere = React.createClass({displayName: "FlatSphere",
    propTypes: {
        bgColor: PropTypes.string,
        text: PropTypes.string
    },
    render() {
        const {bgColor, text} = this.props;
        return (
            React.createElement("div", null, 
            React.createElement("span", {
                className: "text-center", 
                style: {
                    height: '20px',
                    borderRadius: '22px',
                    boxShadow: '1px 2px 4px 0px gray',
                    backgroundColor: bgColor,
                    border: 'solid 0px black',
                    padding: '10px 17px',
                    left: '0',
                    position: 'relative',
                    opacity: '.6'
                }}
            ), 
                React.createElement("span", {style: {paddingLeft: '10px'}}, text)
            )
        );
    }
});

module.exports = FlatSphere;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/FlatSphere/FlatSphere.js
 **/